import {ActionList} from '@primer/styled-react'

import {LinkExternalIcon} from '@primer/octicons-react'

export default function EducationGroup() {
  return (
    <ActionList.LinkItem
      href="/search/advanced"
      // can remove when CSS Modules ships for ActionList
      sx={{
        span: {
          color: 'accent.fg',
        },
      }}
      className="fgColor-accent"
    >
      <ActionList.LeadingVisual className="fgColor-accent">
        <LinkExternalIcon />
      </ActionList.LeadingVisual>
      Advanced search
    </ActionList.LinkItem>
  )
}
